(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('company-subscription-status', {
                parent: 'entity',
                url: '/company-subscription-status?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companySubscriptionStatus.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-subscription-status/company-subscription-statuses.html',
                        controller: 'CompanySubscriptionStatusController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionStatus');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('paymentType');
                        return $translate.refresh();
                    }]
                }
            })
            .state('company-subscription-status-detail', {
                parent: 'entity',
                url: '/company-subscription-status/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companySubscriptionStatus.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-subscription-status/company-subscription-status-detail.html',
                        controller: 'CompanySubscriptionStatusDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'CompanySubscriptionStatus', function ($stateParams, CompanySubscriptionStatus) {
                        return CompanySubscriptionStatus.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('company-subscription-status.new', {
                parent: 'company-subscription-status',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-subscription-status/company-subscription-status-dialog.html',
                        controller: 'CompanySubscriptionStatusDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    createDate: null,
                                    startDate: null,
                                    expireDate: null,
                                    wageFeePercentage: null,
                                    status: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('company-subscription-status', null, {reload: true});
                    }, function () {
                        $state.go('company-subscription-status');
                    });
                }]
            })
            .state('company-subscription-status.edit', {
                parent: 'company-subscription-status',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-subscription-status/company-subscription-status-dialog.html',
                        controller: 'CompanySubscriptionStatusDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['CompanySubscriptionStatus', function (CompanySubscriptionStatus) {
                                return CompanySubscriptionStatus.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('company-subscription-status', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('company-subscription-status.delete', {
                parent: 'company-subscription-status',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-subscription-status/company-subscription-status-delete-dialog.html',
                        controller: 'CompanySubscriptionStatusDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['CompanySubscriptionStatus', function (CompanySubscriptionStatus) {
                                return CompanySubscriptionStatus.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('company-subscription-status', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
